import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs-compat";

@Injectable({
    providedIn: 'root'
})
export class FinalizarRecadastramentoService {

    constructor(private http: HttpClient) { }

    private path = environment.url + 'api/v1/finalizar-recadastramento';

    finalizarRecadastramento(): Observable<any> {
        return this.http.get(this.path)
    }
}